import documentReady from './firewhenready';
import videoBg from './videobg';
import openModal from './modal';


//foreach polyfill
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
    // Yes, there's really no need for `Object.defineProperty` here
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function isOnViewPort(el) {
    let window_height = window.innerHeight;
    let rect = el.getBoundingClientRect();
    return ((rect.top < window_height) && (rect.bottom > 0))
};
 // Used to mean the element was entirely contained in the view port. 
 // Now used to check if the element at one third onto the viewport
function isWithinViewPort(el) {
    let window_height = window.innerHeight;
    let rect = el.getBoundingClientRect();
    return ((rect.bottom - (rect.height * 0.33) >= 0) && (rect.top + (rect.height * 0.33) <= window_height));

};

//$().ready(function(){
//    setupSlideMenu();
//    if ($('form').length){
//        $('form').each(function(){
//            $(this).addClass('floatlabel-active').validate();
//            $(this).find('.js-float-wrap').FloatLabel();
//        });
//    }
//    $('#map-click').click(function(){
//        // shield the map on mobile for easy scrolling
//        $(this).hide();
//    });
//});
window.last_section=null;
function checkVisibility() {
    document.querySelectorAll("section .page-content.has-component").forEach((el =>{
        if (el.component) {
            el.component.isOnViewPort(isOnViewPort(el));
            el.component.isWithinViewPort(isWithinViewPort(el));
        } else {
            //Not all components loaded yet. Try again later...
            setTimeout(checkVisibility,500);
            return;
        }
    }));
     //update analytics if available
    if (typeof ga !== "undefined") {
        let current_section = null;
        document.querySelectorAll("section").forEach(el=>{
            if (isWithinViewPort(el)) {
                current_section = el;
            }
        })
        if (current_section && current_section != window.last_section) {
            window.last_section = current_section;
            ga('set', 'page', current_section.dataset.url);
            ga('send', 'pageview');
        }
    }
}

function iOSVersion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
    return null;
}

function init() {
    let test_gl_canvas = document.createElement( 'canvas' );			
    let gl_enabled = !!(window.WebGLRenderingContext && (test_gl_canvas.getContext('webgl') || test_gl_canvas.getContext('experimental-webgl')));
    let mp4_enabled = !!document.createElement('video').canPlayType &&
               !!document.createElement('video').canPlayType('video/mp4');
    let iosversion = iOSVersion();
    let old_ios = !!iosversion && iosversion[0] <=10;

    // TODO: Check if we can play video without user click. Once we know initialise the video players knowing this.
    function allocate360players(player360) {
        window.keo_360_players =[]; //Keep track of the 360 players in the window in case we need to manipulate them later.
        let nodes = document.querySelectorAll(".wrapper-360");
        let index = 0;
        nodes.forEach(function(el){
            window.keo_360_players.push(new player360(el, ++index, nodes.length));
        });
    }
    if (gl_enabled && mp4_enabled && !old_ios) {
        import(/* webpackChunkName: "360" */ './360').then(({default: player360}) => {allocate360players(player360)}); 
    } else {
        import(/* webpackChunkName: "360" */ './360-disabled').then(({default: player360}) => {allocate360players(player360)}); 
    }
    import(/* webpackChunkName: "grapher" */ './grapher').then(({default: Grapher}) => {
        document.querySelectorAll(".contamination-graph").forEach((el) => {
            new Grapher(el);
        })
    });
    document.querySelectorAll(".video-bg").forEach((el) => {
        new videoBg(el);
    })
    document.addEventListener('scroll',checkVisibility);
    checkVisibility(); // Initial check...
    document.querySelectorAll('.button').forEach(function(el){
        el.addEventListener('click', function(e) {
            e.preventDefault();
            openModal(el.href, 'play');
        });
    });
}

documentReady(init);

